import React from 'react'
import styled from 'styled-components'
import tw from 'twin.macro'

type SpinnerProps = {
  circleColor?: string
  backgroundColor?: string
  width?: number
}

export default function Spinner(props: SpinnerProps) {
  const { circleColor, backgroundColor, width } = props
  return <StyledSpinner circleColor={circleColor} backgroundColor={backgroundColor} width={width} />
}

const StyledSpinner = styled.span<{
  circleColor?: string
  backgroundColor?: string
  width?: number
}>`
  ${tw`inline-block`}
  width: ${(props) => (props.width ? props.width : 13)}px;
  height: ${(props) => (props.width ? props.width : 13)}px;
  border-radius: 50%;
  background: ${(props) => {
    const color = props.circleColor ? props.circleColor : '#ffffff'
    return `linear-gradient(to right, ${color} 10%, ${color} 75%)`
  }};
  position: relative;
  animation: loading 1.4s infinite linear;
  transform: translateZ(0);

  &:before {
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#7D7AF4')};
    width: 50%;
    height: 50%;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  &:after {
    background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : '#7D7AF4')};
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @keyframes loading {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`
